import React, { useState, useEffect } from "react";
import AdminLayout from "./AdminLayout";
import "./AdminForm.css";
import { API_BASE_URL } from "./apiConfig";

const PartyMaster = () => {
  const [activeTab, setActiveTab] = useState("entry");
  const [parties, setParties] = useState([]);
  const [form, setForm] = useState({ partyName: "", gstin: "", address: "", city: "", phone: "" });
  const [message, setMessage] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(true);

  const loadParties = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/party`);
      const data = await res.json();
      setParties(data);
    } catch (err) {
      setMessage({ type: "error", text: "Failed to load parties." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadParties(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.partyName.trim()) {
      setMessage({ type: "error", text: "Party name is required." });
      return;
    }

    const res = await fetch(`${API_BASE_URL}/party`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    if (res.ok) {
      setMessage({ type: "success", text: "Party added successfully." });
      setForm({ partyName: "", gstin: "", address: "", city: "", phone: "" });
      loadParties();
      setActiveTab("view");
    } else {
      setMessage({ type: "error", text: "Could not save party." });
    }
  };

  return (
    <AdminLayout>
      <div className="page-header">
        <h1 className="page-title">Party Master</h1>
      </div>

      <div className="content-card">
        <div className="tab-container">
          <button
            className={`tab-btn ${activeTab === "entry" ? "active" : ""}`}
            onClick={() => setActiveTab("entry")}
          >
            Create New Party
          </button>
          <button
            className={`tab-btn ${activeTab === "view" ? "active" : ""}`}
            onClick={() => setActiveTab("view")}
          >
            View Records ({parties.length})
          </button>
        </div>

        {activeTab === "entry" && (
          <div className="form-wrapper">
            {message.text && (
              <div className={`alert ${message.type === "success" ? "alert-success" : "alert-error"}`}>
                {message.text}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Party / Company Name *</label>
                  <input
                    className="form-control"
                    value={form.partyName}
                    onChange={(e) => setForm({ ...form, partyName: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>GSTIN</label>
                  <input
                    className="form-control"
                    value={form.gstin}
                    onChange={(e) => setForm({ ...form, gstin: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input
                    className="form-control"
                    value={form.address}
                    onChange={(e) => setForm({ ...form, address: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>City</label>
                  <input
                    className="form-control"
                    value={form.city}
                    onChange={(e) => setForm({ ...form, city: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    className="form-control"
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  />
                </div>
              </div>

              <button type="submit" className="btn-submit">Add Party</button>
            </form>
          </div>
        )}

        {activeTab === "view" && (
          <div className="table-wrap">
            {loading ? (
              <div className="empty-state">Loading records...</div>
            ) : (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>GSTIN</th>
                    <th>City</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {parties.length > 0 ? (
                    parties.map((p) => (
                      <tr key={p.partyId}>
                        <td><strong>{p.partyName}</strong></td>
                        <td>{p.gstin || "-"}</td>
                        <td>{p.city || "-"}</td>
                        <td>{p.phone || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="empty-state">
                        <div style={{ marginBottom: "8px", fontSize: "1.2rem" }}>📋</div>
                        No parties found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default PartyMaster;